import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import FormList from "./form-list.jsx";

export default class ManageForms extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            title: '',
            yesLabel: '',
            noLabel: '',
            backLabel: '',
            addNewFormLabel: '',
            forms: []
        }

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onAddNewForm = this.onAddNewForm.bind(this);
        this.onBack = this.onBack.bind(this);
        this.setForms = this.setForms.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get("manage-forms")
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    yesLabel: res.data.yesLabel, 
                    noLabel: res.data.noLabel,
                    backLabel: res.data.backLabel,
                    addNewFormLabel: res.data.addNewFormLabel,
                    forms: res.data.forms
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onAddNewForm() {
        let self = this;
        window.location = context.root() + '/app/add-form/0';
    }

    onBack() {
        let self = this;
        window.location = context.root() + '/app/marketing-admin';
    }

    setForms(data) {
        this.setState({
            forms: data
        });
    }

    render() {
        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <h2 className="text-center ap-title">{this.state.title}</h2>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <Button onClick={this.onAddNewForm} className="btn-info ap-fullsize" >{this.state.addNewFormLabel}</Button>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <Button onClick={this.onBack} className="btn-info ap-fullsize">{this.state.backLabel}</Button>
                        </div>
                    </div>
                    <br />
                     <FormList onChange={this.setForms} forms={this.state.forms} noLabel={this.state.noLabel} yesLabel={this.state.yesLabel}></FormList> 
                </div>
            </div>
        );
    }
}